import React from 'react'
import { Grid, List, ListItem, ListItemText, Collapse } from '@material-ui/core'
import { TextInput, required, maxLength } from 'react-admin'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

class Videos extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  handleClick = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  render() {
    return (
      <>
        <ListItem button onClick={this.handleClick}>
          <ListItemText primary="Videos Module" />
          {this.state.open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={this.state.open} timeout="auto" unmountOnExit>
          <List>
            <ListItem>
              <Grid container>
                <Grid item xs={12}>
                  <TextInput fullWidth source="videoModule.label" label="Videos Module Label" validate={[required(), maxLength(255)]} />
                </Grid>
                <Grid item xs={12}>
                  <TextInput fullWidth source="videoModule.title" label="Videos Module Title" validate={[required(), maxLength(255)]} />
                </Grid>
              </Grid>
            </ListItem>
          </List>
        </Collapse>
      </>
    )
  }
}

export default Videos
